const SlideItem = (props) => {
    const { current, placeId, placeName, img, move} = props
    
    if(current === placeId){
        return(
            <button onClick={move}>
                <div className="slide-item-current">
                    <img alt="" src={img}/>
                    <p className="currentP">{placeName}</p>
                </div>
            </button>
        )
    }else{
        return(
            <button onClick={move}>
                <div className="slide-item-not">
                    <img alt="" src={img}/>
                    <p>{placeName}</p>
                </div>
            </button>
        )
    }
}
export default SlideItem